<template>
  <div class="card">
    <div v-if="loca" class="card-full flex-col" @click="open">
      <iconpark-icon name="plus-circle-fill" size="32" />
      <div class="mt-[15px] text-font-50">
        <slot name="title">{{ title || $t('shang-chuan-wen-jian') }}</slot>
      </div>
    </div>
    <div v-else-if="$slots.frag" class="card-full text-[18px]">
      <slot name="frag" />
    </div>
    <template v-if="loca && $slots.frag">
      <div class="frag top-0 bg-back-3 translate-y-[100%]">
        <slot name="frag" />
      </div>
      <div
        class="frag bottom-0 bg-back-2 -translate-y-[100%] text-font-1"
        @click="open"
      >
        <Resource :src="isDark ? DarkLocalSvg : LocalSvg" alt="" />
        {{ $t('cong-ben-di-shang-chuan') }}
      </div>
    </template>
  </div>
  <!-- <UploadItem
    v-for="x in data"
    :key="x.upload_secret_id"
    :data="x"
    :rights="rights"
    :dataType="dataType"
    :close="close"
  /> -->
</template>
<script lang="ts" setup>
import LocalSvg from '~/assets/svg/up.svg?url'
import DarkLocalSvg from '~/assets/svg/up-dark.svg?url'
withDefaults(
  defineProps<{
    title?: string

    timer?: () => void
    open?: () => void
    close?: (file: any) => void
    dataType?: any
    rights: Record<string, any>[]
    loca?: boolean
  }>(),
  {
    loca: true,
  }
)

const currentTheme = useTheme()
const isDark = computed(() => currentTheme?.value === 'dark')
</script>

<style lang="scss" scoped>
.card {
  @apply relative overflow-hidden bg-back-2 hover:bg-purple-2 hover:border-purple-5 rounded-[10px];
  border: 1px dashed var(--back-6);
  transition: all 0.3s linear;
  &:hover .frag {
    transform: translateY(0);
    opacity: 1;
    &:hover {
      transform: scale(1.15);
    }
  }
}
.frag {
  @apply w-full h-[50%] absolute z-[1] left-0 flex-center text-[18px] gap-x-[15px] opacity-0 cursor-pointer;
  transition:
    transform 0.3s linear,
    opacity 0.3s linear;
}
.card-full {
  @apply flex-center w-full h-full cursor-pointer;
}
</style>
